/**
 * Public curation prompt application wizard (sales lead / package interest).
 * POST /v1/dq_insider/curation_prompt_application — public, no auth.
 */
export const curationPromptApplicationStream = ({ session_id, step, form_data }) => {
    const baseUri = process.env.REACT_APP_MYDQ_API;
    return fetch(`${baseUri}/dq_insider/curation_prompt_application`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            step,
            ...(session_id ? { session_id } : {}),
            ...(form_data ? { form_data } : {}),
        }),
    });
};
